export const SEARCH_FACULTY = 'SEARCH_FACULTY';
export const SELECTED_PROFILE = 'SELECTED_PROFILE';
export const SEARCH_ORGANIZATION = 'SEARCH_ORGANIZATION';
export const STUDENT_LOOKUP = 'STUDENT_LOOKUP';



